"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.WarningMessage=exports.SubHeading1=exports.SubHeading=exports.ModalContainer=exports.GiftCardForm=exports.ErrorMessage=exports.CvvErrorMessage=exports.CreditText=exports.ButtonsContainer=exports.ButtonContainer=void 0;const ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  align-items: center;
  display: flex ;
  flex-direction: column;
`,WarningMessage=exports.WarningMessage=_styledComponents.default.div`
  margin: 8px 0px;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #535250;
`,ErrorMessage=exports.ErrorMessage=_styledComponents.default.div`
  margin: 2px 0px 8px 0px;
  font-size: 12px;
  line-height: 18px;
  color: #C74E4E;
`,ModalContainer=exports.ModalContainer=_styledComponents.default.div`
 min-width: 250px;
  height: content-fit;
  text-align: center;
  max-width: 375px;
  min-height: 250px;
  max-height: 350px;
  padding: 8px;

  .dsCardtext{
    line-height: 32px;
  }

  .subheading-container{
    display: flex;
    align-items: center;
  }
`,ButtonsContainer=exports.ButtonsContainer=_styledComponents.default.div`
 display:flex;
 flex-direction: column;
 justify-content:center;
 align-items:center;

 Button{
  width:100%;
  margin-top: 32px;
 }
 `,SubHeading=exports.SubHeading=_styledComponents.default.div`
 font-size: 16px;
 font-weight: 600;
 line-height: 32px;
 color: #330A0B;
 width: 90%;
 align-items: center;
 margin-top: ${a=>"Checkout"===a?.client?"16px":""};
 `,CvvErrorMessage=exports.CvvErrorMessage=_styledComponents.default.div`
margin: 2px 0px 8px 10px;
font-size: 12px;
line-height: 18px;
color: #C74E4E;
`,SubHeading1=exports.SubHeading1=_styledComponents.default.div` font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 30px;
color: #2a2928;
margin-bottom:24px;`,CreditText=exports.CreditText=_styledComponents.default.div` 
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #2a2928;
margin-top:24px`,GiftCardForm=exports.GiftCardForm=_styledComponents.default.div`
  overflow: hidden;
  padding:0px 12px;
  &.mobile{
    width:${a=>"Checkout"===a?.client?"":"336px"};
    min-width:${a=>"Checkout"===a?.client?"336px":""};
  }
  .paymentMethodsModuleForm{
    /* padding: 0px 15px; */
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-feature-settings: "liga" off, "calt" off;
    font-style: normal;
    font-weight: normal;
    margin: ${a=>"Checkout"===a?.client?" 8px 0px 16px 0px":"16px 0"} ;
    color: #7D7B78;
  }

  .paymentMethodsModuleForm .submitErrorMsg {
    color: #cc4545;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-size: 12px;
  }

  .paymentMethodsModuleForm .crossIcon{
    color: #fff;
    background-color: #dd1e25;
    border-radius: 50%;
    padding: 8px;
  }


  .paymentMethodsModuleForm .cVVInputContainer {
    margin-left: 12px;
  }

  .paymentMethodsModuleForm .inputContainer .input {
    box-shadow: none;
    border-radius: 8px;
    border: 1px solid #7d7b78;
    font-size: 16px;
    box-sizing: border-box;
    background: none;
    padding: 20px 16px 6px 16px;
    width: 100%;
    height: 56px;
    color: #2b0810;
  }

  .paymentMethodsModuleForm .inputContainer  {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
  }

  .paymentMethodsModuleForm .inputContainer:focus-within label {
    transform: translate(0, 10px) scale(0.7);
  }

  .paymentMethodsModuleForm .inputContainer label {
    color: #7d7b78;
    padding: 0px 16px;
    position: absolute;
    transform: translate(0, 19px) scale(1);
    transform-origin: top left;
    transition: all 0.2s ease-out;
    z-index: -1;
  }

  .paymentMethodsModuleForm .inputContainer .activeLabel {
    transform: translate(0, 10px) scale(0.72);
    padding-left:24px
  }
  .paymentMethodsModuleForm .inputContainer .activeCardNumberLabel {
    transform: translate(0px, 10px) scale(0.72);
    padding-left:13px;
    font-weight:normal;
  }

  .closeButton {
    height: 20px;
    margin-right: 5px
  }

  .paymentMethodsModuleForm .inputContainer .input.error{
    border: 1px solid #cc4545;
    font-weight: normal;
  }

  .paymentMethodsModuleForm .inputContainer .input:focus,
  .paymentMethodsModuleForm .inputContainer .input.error:focus {
    border: 0px solid #3E7CA8 !important;
    outline: #3E7CA8 solid 2px !important;
  }

  .paymentMethodsModuleForm .cardNumberContainer {
    display: flex;
    border: 1px solid #7d7b78;
    box-sizing: border-box;
    border-radius: 8px;
    /* margin: 16px 8px 0px 8px; */
    box-shadow: none;
    font-size: 16px;
    color: #2b0810;
    text-align: left;
    align-items: center;
    justify-content: space-between;
    padding-right: 2px;
  }

  .paymentMethodsModuleForm .cardNumberContainer.error  {
    border: 1px solid #cc4545;
    font-weight:normal;
  }

  .paymentMethodsModuleForm .cardNumberContainer:focus-within,
  .paymentMethodsModuleForm .cardNumberContainer.error:focus-within {
    border: 0px solid #3E7CA8 !important;
    outline: #3E7CA8 solid 2px !important;
  }

  .paymentMethodsModuleForm .cardNumber {
    height: 36px;
    box-sizing: border-box;
    border: none !important;
    font-size: 16px;
    margin: 10px 8px;
    background: none;
    outline: none !important;
    color: rgb(43, 8, 16);
    padding: 20px 16px 6px 0px;
  }

  .paymentMethodsModuleForm .cardNumber:focus {
    outline: none !important;
  }

  .paymentMethodsModuleForm .monthCVVContainer{
    display: flex;
  }

  .paymentMethodsModuleForm .ctnBtnContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .backdrop{
    z-index: 5 !important;
  }
`;// export const SubHeading = styled.div` font-style: normal;
// font-weight: 600;
// font-size: 16px;
// line-height: 20px;
// margin: 24px 0px 24px 2px;
// color: #2a2928;`;